import { ParsedTab } from '../explore/components/tabs/store'
import { ConnectTab } from './connect'
import { APIExplorerTab } from './api-explorer'
import { BreadcrumbStickyContainer } from '../explore/components/tabs/dashboard-breadcrumb'
import { Breadcrumb, BreadcrumbItem } from '~/sotano-kit/primitives/breadcrumb'
import { useIsExternalVisitor } from '~/hooks-data/use-user-role'
import { BreadcrumbWebhook } from '../explore/components/tabs/dashboard-breadcrumb/webhook'

export const DevTabContent = ({
  parsedTab,
}: {
  parsedTab: Extract<ParsedTab, { type: 'dev' }>
}) => {
  const isVisitor = useIsExternalVisitor()
  if (isVisitor) return null

  return (
    <>
      <BreadcrumbStickyContainer>
        <Breadcrumb>
          <BreadcrumbItem active={false}>Developers</BreadcrumbItem>
          <BreadcrumbItem active>{parsedTab.label}</BreadcrumbItem>
        </Breadcrumb>

        {parsedTab.tab === 'connect' && <BreadcrumbWebhook />}
      </BreadcrumbStickyContainer>
      {parsedTab.tab === 'api-explorer' ? <APIExplorerTab /> : <ConnectTab />}
    </>
  )
}
